import * as m from '@/paraglide/messages.js';

/**
 * The chrome the sign-in screen already wears — the ATS tile, the brand gradient, the card
 * surface — lifted out so the invitation and reset screens are recognisably the same product.
 * Someone opening a link from their inbox has no other signal that they are in the right place.
 */
export function AuthCard({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-3 sm:p-6">
      <div className="w-full max-w-sm">
        <div className="surface-elevation rounded-xl border border-border bg-card p-4 sm:p-8">
          <div className="flex flex-wrap items-center gap-3">
            <span
              aria-hidden="true"
              className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-linear-to-br from-brand to-brand-end text-sm font-bold tracking-tight text-primary-foreground"
            >
              ATS
            </span>
            <div className="min-w-0">
              <h1 className="text-base font-semibold tracking-tight sm:text-lg">{m.app_name()}</h1>
              <p className="text-xs text-muted-foreground">ATS digital</p>
            </div>
          </div>
          <h2 className="mt-6 text-base font-semibold">{title}</h2>
          {description && (
            <p className="mt-2 text-sm leading-6 text-muted-foreground">{description}</p>
          )}
          {children}
        </div>
      </div>
    </main>
  );
}
